import { Link } from 'react-router-dom'
import { Mail, Phone, MapPin } from 'lucide-react'
import LogoIcon from '/images/Logo-Icon.svg'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img src={LogoIcon} alt="Cirurgia Autorizada" className="w-8 h-8 mr-3" />
              <span className="text-xl font-bold">Cirurgia Autorizada</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              A plataforma inteligente que simplifica e centraliza o fluxo cirúrgico, 
              conectando clínicas, secretariados e cirurgiões para uma gestão eficiente e sem estresse.
            </p>
            <div className="flex space-x-4">
              <div className="flex items-center text-gray-300">
                <Mail className="h-4 w-4 mr-2" />
                <span className="text-sm">contato@cirurgiaautorizada.com.br</span>
              </div>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/sou-clinica-medica" className="text-gray-300 hover:text-white transition-colors">
                  Para Clínicas
                </Link>
              </li>
              <li>
                <Link to="/sou-secretariao" className="text-gray-300 hover:text-white transition-colors">
                  Para Secretariados
                </Link>
              </li>
              <li>
                <Link to="/sou-cirurgião" className="text-gray-300 hover:text-white transition-colors">
                  Para Cirurgiões
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-300">
                <Phone className="h-4 w-4 mr-2" />
                <span className="text-sm">(85) 98228-6045</span>
              </li>
              <li className="flex items-center text-gray-300">
                <Mail className="h-4 w-4 mr-2" />
                <span className="text-sm">contato@cirurgiaautorizada.com.br</span>
              </li>
              <li className="flex items-start text-gray-300">
                <MapPin className="h-4 w-4 mr-2 mt-1" />
                <span className="text-sm">Fortaleza, CE - Brasil</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 Cirurgia Autorizada. Todos os direitos reservados.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/politica-de-privacidade" className="text-gray-400 hover:text-white text-sm transition-colors">
                Política de Privacidade
              </Link>
              <Link to="/termos-de-uso" className="text-gray-400 hover:text-white text-sm transition-colors">
                Termos de Uso
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

